export default __webpack_public_path__ + "static/media/gallery-wip-denix-scope-mount-hole_03.8400e8d9.jpg";